import {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
  useMemo,
} from 'react';
import { twMerge } from 'tailwind-merge';
import { IsVisible, SkeletonLoader } from '../../../utils';

interface ITableBodyProps
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLTableSectionElement>,
    HTMLTableSectionElement
  > {
  isLoading?: boolean;
  linesForLoading?: number;
}

export function TableBody({
  children,
  className,
  isLoading = false,
  linesForLoading = 5,
  ref,
  ...rest
}: PropsWithChildren<ITableBodyProps>) {
  const loadingRowHeight = useMemo(() => {
    const loadingRowHeightValue = 40 * linesForLoading;

    return `h-[${loadingRowHeightValue}px]`;
  }, [linesForLoading]);

  return (
    <tbody className={twMerge('', className)} ref={ref} {...rest}>
      <IsVisible when={isLoading}>
        <tr className={loadingRowHeight}>
          <td className="p-0 text-center" colSpan={100}>
            <SkeletonLoader
              borderRadius={0}
              count={linesForLoading}
              height={38}
            />
          </td>
        </tr>
      </IsVisible>
      <IsVisible when={!isLoading}>{children}</IsVisible>
    </tbody>
  );
}
